export const hasNonblankPatientInstructions = (
  instructions: string[] | null | undefined,
): boolean => instructions?.some((instruction) => instruction.trim().length > 0) ?? false;

export const normalizePatientInstructions = (
  instructions: string[] | null | undefined,
): string[] =>
  (instructions ?? [])
    .map((instruction) => instruction.trim())
    .filter((instruction) => instruction.length > 0);
